import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";

const AccountStatement = () => {
  const { user } = useContext(AuthContext);
  const [statements, setStatements] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatements = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/api/accountStatements/${user?.id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        const data = response.data?.content || [];
        setStatements(data);
      } catch (error) {
        console.error("Failed to fetch data:", error);
        setStatements([]); // fallback to empty array on error
      } finally {
        setLoading(false);
      }
    };

    if (user?.id) {
      fetchStatements();
    }
  }, [user?.id]);

  return (
    <div className="p-4 dark:bg-gray-900 dark:text-white">
      <div className="overflow-x-auto rounded-xl shadow-md">
        <table className="min-w-full bg-white border border-gray-200 text-sm text-gray-800 dark:bg-gray-800 dark:text-white">
          <thead className="bg-gray-100 text-left text-xs uppercase tracking-wider text-gray-600 dark:bg-gray-700 dark:text-white">
            <tr>
              <th className="px-4 py-3">S. No.</th>
              <th className="px-4 py-3">Type</th>
              <th className="px-4 py-3">Company</th>
              <th className="px-4 py-3">Initiated By</th>
              <th className="px-4 py-3">Before Email</th>
              <th className="px-4 py-3">After Email</th>
              <th className="px-4 py-3">Before SMS</th>
              <th className="px-4 py-3">After SMS</th>
              <th className="px-4 py-3">Rate (Email + SMS)</th>
              <th className="px-4 py-3">Transaction Date</th>
              <th className="px-4 py-3">Remarks</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="px-4 py-3 text-center" colSpan="11">
                  Loading...
                </td>
              </tr>
            ) : statements.length === 0 ? (
              <tr>
                <td className="px-4 py-3 text-center" colSpan="11">
                  No records found.
                </td>
              </tr>
            ) : (
              statements.map((item, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 border-t border-gray-200 dark:hover:bg-gray-900"
                >
                  <td className="px-4 py-2">{index + 1}</td>
                  <td className="px-4 py-2">{item.type}</td>
                  <td className="px-4 py-2">{item.companyName}</td>
                  <td className="px-4 py-2">{item.initiatedBy}</td>
                  <td className="px-4 py-2">{(item.beforeEmailCredit).toFixed(2)}</td>
                  <td className="px-4 py-2">{(item.afterEmailCredit).toFixed(2)}</td>
                  <td className="px-4 py-2">{(item.beforeSMSCredit).toFixed(2)}</td>
                  <td className="px-4 py-2">{(item.afterSMSCredit).toFixed(2)}</td>
                  <td className="px-4 py-2 font-semibold text-blue-600">
                  ₹ {(item.emailAmount != null ? item.emailAmount : item.smsAmount)?.toFixed(2)}
                  </td>
                  <td className="px-4 py-2">
                    {new Date(item.transactionDate).toLocaleString()}
                  </td>
                  <td className="px-4 py-2">{item.remarks}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AccountStatement;
